const preFilters = {
    state: {
        fromSubFilter: null,
        fromUsersFilter: null,
        subscriptionPreFilterMode: false,
        treatmentPreFilterMode: false,
        ordersPreFilterMode: false,
        fromSubscription: false,
        subscriptionFilterData: null,
    },
    mutations: {
        setFromSubFilter(state, data) {
            state.fromSubFilter = data;
        },
        setFromUsersFilter(state, data) {
            state.fromUsersFilter = data;
        },
        setSubscriptionPreFilterMode(state, mode) {
            state.subscriptionPreFilterMode = mode;
        },
        setTreatmentPreFilterMode(state, mode) {
            state.treatmentPreFilterMode = mode;
        },
        setOrdersPreFilterMode(state, mode) {
            state.ordersPreFilterMode = mode;
        },
        setFromSubscription(state, mode) {
            state.fromSubscription = mode;
        },
        clearFromUsersFilter(state) {
            state.fromUsersFilter = null;
        },
        clearFromSubFilter(state) {
            state.fromSubFilter = null;
        },
        setSubscriptionFilterData(state, mode) {
            state.subscriptionFilterData = mode;
        },
    },
    getters: {
        getFromSubFilter(state) {
            return state.fromSubFilter;
        },
        getFromUsersFilter(state) {
            return state.fromUsersFilter;
        },
        getSubscriptionPreFilterMode(state) {
            return state.subscriptionPreFilterMode;
        },
        getTreatmentPreFilterMode(state) {
            return state.treatmentPreFilterMode;
        },
        getOrdersPreFilterMode(state) {
            return state.ordersPreFilterMode;
        },
        getFromSubscription(state) {
            return state.fromSubscription;
        },
        getSubscriptionFilterData(state) {
            return state.subscriptionFilterData;
        },
    },
};

export default preFilters;
